import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonConfigurationTestPermissionOverview, CommonConfigurationTestPermissionTopics } from "../../CommonComponents/CommonConfigurationTestPermissionViews";

export const ConfigurationTestPermissionsRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.configuration.testPermissions,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationTestPermissionOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationTestPermissionTopics />;
    },
};
